<template>
    <v-dialog eager v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card >

            <v-toolbar fixed dark color="primary">
                <v-btn icon dark @click="dialog = false">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title v-if="(!multipleOffices && $vuetify.breakpoint.smAndDown) || $vuetify.breakpoint.mdAndUp">Agendar nueva cita</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-select
                    v-if="multipleOffices"
                    :items="provider.institution.branch_offices"
                    return-object
                    :item-text="internal ? 'name' : 'address'"
                    label="Sucursal"
                    color="primary darken-2"
                    style="z-index: 1000; max-width: 400px"
                    hide-details
                    v-model="defaultOffice">
                    <template v-slot:selection="{item}">
                      <div style="width: 90%" class="text-truncate">{{internal ? item.name : item.address}}</div>
                    </template>
                </v-select>
            </v-toolbar>

            <v-sheet class="py-3" />

            <v-card-text class="mt-4 pb-4">
                <appointment-steps
                        v-if="individualProvider && !!provider || ( !individualProvider  && !!office)"
                        :branch-office="defaultOffice"
                        ref="stepper"
                        :default-appointment="defaultAppointment"
                        v-on:close="onClose"
                        v-on:appointment-created="onAppointmentCreated"
                        :provider="provider.id"
                        :internal="internal"
                        :individual-provider="individualProvider"
                        fullscreen />
            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>

    import AppointmentSteps from '@/components/appointments/AppointmentSteps'
    import {mapState} from 'vuex'

    export default{
        components: {AppointmentSteps},
        props: {
          internal: {
            type: Boolean,
            default: false
          },
          serviceProvider:{
            type: Object
          },
          branchOffice:{
            type: Object
          }
        },
        data(){
            return {
                dialog: false,
                defaultAppointment: null,
                defaultOffice: null
            }
        },
        mounted(){
          const vm = this
          if(vm.branchOffice){
            vm.defaultOffice = vm.branchOffice
          }else{
            if(vm.provider && vm.provider.institution && vm.provider.institution.branch_offices.length > 0){
              vm.defaultOffice = vm.provider.institution.branch_offices[0]
            }
          }
        },
        methods: {
            onClose(){
                this.hide()
            },
            onAppointmentCreated(){
                this.$emit('appointment-created')
            },
            show(defaultAppointment = null){

              const vm = this

                vm.dialog = true
                if(defaultAppointment){
                    vm.defaultAppointment = defaultAppointment
                }
                setTimeout(function(){
                  vm.$refs.stepper.loadSchedules()
                }, 2000)
            },

            hide(){
                this.dialog = false
            }

        },
        watch:{
            defaultOffice(){
              if(this.$refs.stepper) this.$refs.stepper.reset()
            },
            branchOffice(val){
              const vm = this
              vm.defaultAppointment = val
            },
            dialog(val){
                if(!val){
                    this.defaultAppointment = null
                    this.$refs.stepper.reset()
                }
            }
        },
        computed: {
            ...mapState(['currentProvider', 'currentBranchOffice']),
          multipleOffices(){
            const vm = this
            return vm.provider
                && vm.provider.institution
                && vm.provider.institution.branch_offices
                && vm.provider.institution.branch_offices.length > 1
          },
          individualProvider(){
            var vm = this
            return !!vm.provider && !vm.provider.institution
          },

          office(){
              const vm = this
              return vm.defaultOffice || vm.currentBranchOffice
          },

          provider(){
            const vm = this
            return vm.serviceProvider || vm.currentProvider || null
          }

        }
    }
</script>